/* eslint-disable */
import { GetterTree } from "vuex";
import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { UserState } from "@/types/user";

const getters: GetterTree<UserState, RootState> = {
  list: state => {
    return state.pagination ? state.pagination.data : [];
  },
  salesList: state => {
    return state.pagination ? state.pagination.data : [];
  },
  userList: state => {
    return state.pagination ? state.pagination.data : [];
  },

  customerList: state => {
    return state.pagination ? state.pagination.data : [];
  },
  subcontractorList: state => {
    return state.pagination ? state.pagination.data : [];
  },

  pagination: state => {
    return state.pagination || new Pagination();
  },
  single: state => {
    return state.user || new User();
  },
  find: state => (id: number) => {
    return state.pagination
      ? state.pagination.data.find(user => {
          return user.id == id;
        })
      : new User();
  },

  userSelectItem: state => {
    return state.pagination
      ? state.pagination.data.filter(user => user.role == 10).
      map(user => User.toSelectItem(user))
      : [];
  },
  salesSelectItem: state => {
    return state.pagination
      ? state.pagination.data.filter(user => user.role == 7).
      map(user => User.toSelectItem(user))
      : [];
  },

  selectItem: state => {
    return state.pagination
      ? state.pagination.data.map(user => User.toSelectItem(user))
      : [];
  },

  isAdmin: state => 0 < state.user!.role && state.user!.role <= 5,
  isSales: state => state.user!.role == 7,
  isUser: state => state.user!.role == 10,
  isCustomer: state => state.user!.role == 15,
  isSubcontractor: state => state.user!.role == 20,

};

export default getters;
